import React, { useState,useEffect} from 'react'
import { Card } from 'primereact/card';
import { Paginator } from 'primereact/paginator';
import { useContext } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button'; 
import { getAllManuals,getAllKits,getAllReports,getAllUserManuals } from '../api/axiosManuals';
import DataContext from '../context/DataContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { API_URL } from '../config/constants';

 



const About = () => {
  const { kits,setKits,reports,setReports,userManuals,setUserManuals, setFetcherror } = useContext(DataContext);
  
  
  const [isLoadingKits, setIsLoadingKits] = useState(true);
  const [totalCountKits, setTotalCountKits] = useState(0);
  const [firstKits, setFirstKits] = useState(0);
  const [rowsKits, setRowsKits] = useState(10);

  const [isLoadingReports, setIsLoadingReports] = useState(true);
  const [totalCountReports, setTotalCountReports] = useState(0);
  const [firstReports, setFirstReports] = useState(0);
  const [rowsReports, setRowsReports] = useState(10);

  const [isLoadingUserManuals, setIsLoadingUserManuals] = useState(true);
  const [totalCountUserManuals, setTotalCountUserManuals] = useState(0);
  const [firstUserManuals, setFirstUserManuals] = useState(0);
  const [rowsUserManuals, setRowsUserManuals] = useState(10);

  useEffect(() => {
    getAllKits(setKits, setFetcherror, setIsLoadingKits, setFirstKits, setRowsKits,undefined,setTotalCountKits);
    getAllReports(setReports, setFetcherror, setIsLoadingReports, setFirstReports, setRowsReports,undefined,setTotalCountReports);
    getAllUserManuals(setUserManuals, setFetcherror, setIsLoadingUserManuals, setFirstUserManuals, setRowsUserManuals,undefined,setTotalCountUserManuals);
    
  }, []);  
    
  const onPageChangeKits = (event) => {
      getAllKits( setKits,setFetcherror,setIsLoadingKits,setFirstKits,setRowsKits,event,setTotalCountKits);
  };
  const onPageChangeReports = (event) => {
      getAllReports( setReports,setFetcherror,setIsLoadingReports,setFirstReports,setRowsReports,event,setTotalCountReports);
  };
  const onPageChangeUserManuals = (event) => {
      getAllUserManuals( setUserManuals,setFetcherror,setIsLoadingUserManuals,setFirstUserManuals,setRowsUserManuals,event,setTotalCountUserManuals);
  };
  
  const limitOptions = [5, 10, 20, 30, 50];
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);

  const pagemainHeader = (
    <div className='text-center'> RESOURCES CENTRE</div>
  );
  
  return (
    <>
      <Card title={pagemainHeader} className='m-4'>
        <TabView>
          <TabPanel header="Self Help Kits">
               {/* Help Kits Card */}
                  <Card title="Self Help Kits" className='m-1'>

                    {!isLoadingKits &&
                        <DataTable
                          value={kits}
                          showGridlines
                          emptyMessage="No Kits Found"
                        >
                          <Column header="S/N" body={(rowData) => kits.indexOf(rowData) + 1+ firstKits} sortable> </Column>
                          <Column header="Name" body={(rowData) => rowData.name} sortable></Column>
                          <Column header="Actions" body={(rowData) => (
                            <div className='flex flex-row'>
                              <Button
                                icon="pi pi-file-pdf"
                                label="Download"
                                outlined
                                severity="success"
                                aria-label="Download"
                                onClick={() => { window.open(`${API_URL}/fsmanuals/${rowData.uri}`, '_blank'); }} 
                                className='py-1 px-3'
                              />
                            </div>          
                          )}>
                          </Column>
                        </DataTable>
                      } 
                      
                      {isLoadingKits && 
                      
                      <DataTable value={skeletonitems} className="p-datatable-striped">
                      <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
                      <Column field="Name" header="Name" style={{ width: '25%' }} body={<Skeleton />}></Column>
                      <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
                      </DataTable>
                      }

                      {!isLoadingKits &&
                        <Paginator
                          first={firstKits}
                          rows={rowsKits}
                          totalRecords={totalCountKits}
                          rowsPerPageOptions={limitOptions}
                          onPageChange={onPageChangeKits}
                        />
                      }

                    </Card>
          </TabPanel>
          
                  <TabPanel header="Human Rights Reports">
                     {/* Reports */}
                    <Card title="Human Rights Reports" className='m-1'>

                      {!isLoadingReports &&
                          <DataTable
                            value={reports}
                            showGridlines
                            emptyMessage="No Reports Found"
                          >
                            <Column header="S/N" body={(rowData) => reports.indexOf(rowData) + 1+ firstReports} sortable> </Column>
                            <Column header="Name" body={(rowData) => rowData.name} sortable></Column>
                            <Column header="Actions" body={(rowData) => (
                              <div className='flex flex-row'>
                                <Button
                                  icon="pi pi-file-pdf"
                                  label="Download"
                                  outlined
                                  severity="success"
                                  aria-label="Download"
                                  onClick={() => {window.open(`${API_URL}/fsmanuals/${rowData.uri}`, '_blank'); }} 
                                  className='py-1 px-3'
                                />
                              </div>          
                            )}>
                            </Column>
                          </DataTable>
                        } 
                  
                        {isLoadingReports && 
                        
                        <DataTable value={skeletonitems} className="p-datatable-striped">
                        <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        <Column field="Name" header="Name" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        </DataTable>
                        }

                        {!isLoadingReports &&
                          <Paginator
                            first={firstReports}
                            rows={rowsReports}
                            totalRecords={totalCountReports}
                            rowsPerPageOptions={limitOptions}
                            onPageChange={onPageChangeReports}
                          />
                        }

                </Card>
          </TabPanel>
          
                  <TabPanel header="System User Manuals">
                    {/* Reports */}
                    <Card title="System User Manuals" className='m-1'>

                      {!isLoadingUserManuals &&
                          <DataTable
                            value={userManuals}
                            showGridlines
                            emptyMessage="No Manuals Found"
                          >
                            <Column header="S/N" body={(rowData) => userManuals.indexOf(rowData) + 1+ firstUserManuals} sortable> </Column>
                            <Column header="Name" body={(rowData) => rowData.name} sortable></Column>
                            <Column header="Actions" body={(rowData) => (
                              <div className='flex flex-row'>
                                <Button
                                  icon="pi pi-file-pdf"
                                  label="Download"
                                  outlined
                                  severity="success"
                                  aria-label="Download"
                                  onClick={() => {window.open(`${API_URL}/fsmanuals/${rowData.uri}`, '_blank'); }} 
                                  className='py-1 px-3'
                                />
                              </div>          
                            )}>
                            </Column>
                          </DataTable>
                        } 
                  
                        {isLoadingUserManuals && 
                        
                        <DataTable value={skeletonitems} className="p-datatable-striped">
                        <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        <Column field="Name" header="Name" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
                        </DataTable>
                        }

                        {!isLoadingUserManuals &&
                          <Paginator
                            first={firstUserManuals}
                            rows={rowsUserManuals}
                            totalRecords={totalCountUserManuals}
                            rowsPerPageOptions={limitOptions}
                            onPageChange={onPageChangeUserManuals}
                          />
                        }

                </Card>
          </TabPanel>
          
                  
              </TabView>

      </Card>
    </>
      
  )
}

export default About